import { SHOW_ALERT_MESSAGE } from './Alerts.types'
import { LoaderScreenType } from './Common.reducer'

export const showGLLoader = (payload: LoaderScreenType) => ({
  type: 'SHOW_GL_LOADER',
  payload,
})

export type CommonActionTypes = ReturnType<typeof showGLLoader>
